import { createColumnHelper } from "@tanstack/react-table";
import { getStatusBadge } from "../../../component/table-utils/get-status-badge";
import React from "react";
import DotsVertical from "../../../assets/dotsVertitical";
import truncate from "../../../lib/utils/truncate";
import BinIcon from "../../../assets/bin";
import { PhoneNumberRecord } from "../../../lib/types";
import countryList from "react-select-country-list";
import formatDate from "../../../lib/utils/formatDate";

const allcountryList = countryList().getData();
type BillingsDataType = {
  _id: string;
  user_id: string;
  wallet_id: string;
  transaction_type: "debit" | "credit"; // assuming only two possible types
  amount: number;
  description: string;
  currency: string; // optionally restrict to 'USD' | 'EUR' | etc.
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  __v: number;
};

export type TeamDataType = {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  role: string;
};

const columnHelper = createColumnHelper<BillingsDataType>();
const teamColumnHelper = createColumnHelper<TeamDataType>();
const phoneColumnHelper = createColumnHelper<PhoneNumberRecord>();

export const billingColumns = [
  columnHelper.display({
    id: "amount",
    size: 100,
    header: "AMOUNT PAID",
    cell: ({ row }) => <>{row.original.amount}</>,
  }),
  columnHelper.display({
    id: "date",
    size: 150,
    header: "PAYMENT DATE",
    cell: ({ row }) => <>{formatDate(row.original.createdAt)}</>,
  }),
  columnHelper.display({
    id: "method",
    size: 200,
    header: "DESCRIPTION",
    cell: ({ row }) => <>{row.original.description}</>,
  }),
  columnHelper.display({
    id: "status",
    size: 50,
    header: "TYPE",
    cell: ({ row }) => <>{getStatusBadge(row.original.transaction_type)}</>,
  }),
];

export const teamColumns = [
  teamColumnHelper.display({
    id: "firstName",
    size: 150,
    header: "FIRST NAME",
    cell: ({ row }) => <>{row.original.firstName}</>,
  }),
  teamColumnHelper.display({
    id: "lastName",
    size: 150,
    header: "LAST NAME",
    cell: ({ row }) => <>{row.original.lastName}</>,
  }),
  teamColumnHelper.display({
    id: "email",
    size: 250,
    header: "EMAIL",
    cell: ({ row }) => <>{truncate(row.original.email, 30)}</>,
  }),
  teamColumnHelper.display({
    id: "role",
    size: 200,
    header: "ROLE",
    cell: ({ row }) => <>{row.original.role}</>,
  }),
  teamColumnHelper.display({
    id: "actions",
    size: 20,
    cell: ({
      row,
      table: {
        options: { meta },
      },
    }) => (
      <div
        className="cursor-pointer"
        onClick={() => meta?.handleClick(row.original.id)}
      >
        <DotsVertical className={"color:primary-dark"} />
      </div>
    ),
  }),
];

export const phoneColumns = [
  phoneColumnHelper.display({
    id: "phoneNumber",
    size: 100,
    header: "PHONE NUMBER",
    cell: ({ row }) => <>{row.original?.phone_number}</>,
  }),
  phoneColumnHelper.display({
    id: "country",
    size: 100,
    header: "COUNTRY",
    cell: ({ row }) => (
      <>
        {
          allcountryList.find(
            (country: { value: string; label: string }) =>
              country?.value === row.original?.country_code
          )?.label
        }
      </>
    ),
  }),
  phoneColumnHelper.display({
    id: "monthlyCost",
    size: 300,
    header: "MONTHLY COST",
    cell: ({ row }) => <>{}</>,
  }),

  phoneColumnHelper.display({
    id: "actions",
    size: 20,
    cell: ({
      row,
      table: {
        options: { meta },
      },
    }) => (
      <div
        className="cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          meta()?.handleClick(row);
        }}
      >
        <BinIcon className={"text-[red]"} />
      </div>
    ),
  }),
];
